import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-customer-configuration',
  templateUrl: './customer-configuration.component.html',
  styleUrls: ['./customer-configuration.component.scss']
})
export class CustomerConfigurationComponent implements OnInit {
  @Input() customerId: string = ''
  @Input() isView: boolean = false
  @Output() onChangeGroupCustomerIds: EventEmitter<any> = new EventEmitter();
  @Output() originGroupCustomerIds: EventEmitter<any> = new EventEmitter();
  inputGroupValue: string;
  inputCustomerValue: string;
  filteredGroupOptions = [];
  nzCheckLoadingGroup = false;
  selectedGroup = [];
  isFormChanging: boolean = false;
  columnDefinitions = [
    { def: "id", showMobile: true },
    { def: "name", showMobile: true },
    { def: "action", showMobile: true },
  ];
  permissions: any
  filterRow = ['stt', 'filterName', 'actionFilter']
  isShowFilter: boolean = false
  @ViewChild('suffixGroupInput', { static: false }) suffixGroupInput: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChildren('focusInput') focusInput;
  error = '';
  name = '';
  isExpanded = true;
  subscription: Subscription;
  displayedColumns: string[] = [];
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  constructor(
    private customerService: CustomerService,
    public commonService: CommonService,
    private responsiveService: ResponsiveService,
    private toastr: ToastrService,
    private message: Message,
    private dialog: MatDialog
  ) {
    this.permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
  }

  ngOnInit() {
    if (this.customerId) {
      const body = {
        customerId: this.customerId
      }
      this.customerService.getGroupOfCustomer(body).subscribe(rs => {
        this.bindData(rs)
      })
    }
    this.loadData();
  }

  ngAfterViewInit() {
    if (this.focusInput && this.focusInput.first && this.focusInput.first.nativeElement) {
      setTimeout(_ => this.focusInput.first.nativeElement.focus());
    }
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status' && cd.def !== 'check'))
    //     .map(cd => cd.def);
    // }
  }

  onChangeGroupSignSearch($event) {
    let body = {
      keyword: this.inputGroupValue,
      groupCustomerIds: this.selectedGroup.map(item => item.id),
      page: 0,
      pageSize: 10,
    }

    this.nzCheckLoadingGroup = true;
    this.customerService.filterGroupCustomer(body)
      .subscribe(result => {
        if (result && result.success) {
          this.filteredGroupOptions = result.data.content;
          this.nzCheckLoadingGroup = false;
        } else {
          this.toastr.error(result.massage)
          this.nzCheckLoadingGroup = false;
        }
      }, error => {
        this.nzCheckLoadingGroup = false;
      });

  }

  checkEnterpriseName(group) {
    const enterpriseId = localStorage.getItem('enterpriseId')
    if (group.enterpriseId && group.enterpriseId !== enterpriseId) {
      return group.name + ' - ' + group.enterpriseName
    } else {
      return group.name
    }
  }

  autocompleteGroupSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.isFormChanging = true;
      this.selectedGroup.unshift(model);
      this.onChangeGroupCustomerIds.emit(this.selectedGroup.map(item => item.id));
      this.onChangeGroupSignSearch('')
      this.loadData()
    }
  }

  loadData() {
    let data = this.selectedGroup.filter(item => {
      if (item.name.toLowerCase().includes(this.name.trim().toLowerCase() || '')) {
        return item;
      }
    }) || []
    this.dataSource.data = data
  }

  private bindData(rs: any) {
    if (rs == null || rs.data == null) {
      return 0;
    }
    this.dataSource.data = rs.data;
    this.selectedGroup = rs.data;
    this.originGroupCustomerIds.emit(rs.data);
    this.onChangeGroupCustomerIds.emit(this.selectedGroup.map(item => item.id));
  }

  removeGroup(groupId: number, groupName: string) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_group_customer'), groupName)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.selectedGroup = this.selectedGroup.filter(item => item.id !== groupId);
        this.onChangeGroupCustomerIds.emit(this.selectedGroup.map(item => item.id));
        this.loadData();
      }
      if (this.focusInput && this.focusInput.first && this.focusInput.first.nativeElement) {
        this.focusInput.first.nativeElement.focus();
      }
    });
  }

  openFilter() {
    this.isShowFilter = !this.isShowFilter;
    if (!this.isShowFilter) {
      this.name = ''
    }
    this.loadData();
  }

  checkIndexOfElement(element){
    const index = this.dataSource.filteredData.indexOf(element) + 1
    if((this.isShowFilter && index % 2 !== 0) || (!this.isShowFilter && index % 2 == 0)){
      return true
    }
    return false
  }

  isDisabledInput() {
    if(this.commonService.checkDefaultAdmin()) {
      return false;
    }
    if(!this.permissions.includes(404) && !this.permissions.includes(4)) {
      return true;
    }
    return false;
  }

}
